import React from 'react';

const QualLeaderboardArticle = (props) => {
    if (!props.location || !props.location.competitionStatus) return null;

    return (
        <h3 className="qual-leaderboard__article-title"
            dangerouslySetInnerHTML={{ __html: props.location.competitionStatus }}
        />
    );
};

export default QualLeaderboardArticle;
